import {
  AddProgramRequest,
  UpdateProgramRequest,
} from "@platform-app/app/core/api/models";

export class GetOrganizationPrograms {
  static readonly type = "[Organization Programs] Get Programs";
  constructor(public payload: { schoolId: string }) {}
}

export class DeleteOrganizationProgram {
  static readonly type = "[Organization Programs] Delete Program";
  constructor(public payload: { schoolId: string; programId: string }) {}
}

export class AddOrganizationProgram {
  static readonly type = "[Organization Programs] Add Program";
  constructor(
    public payload: { schoolId: string; program: AddProgramRequest },
  ) {}
}

export class UpdateOrganizationProgram {
  static readonly type = "[Organization Programs] Update Program";
  constructor(
    public payload: {
      schoolId: string;
      programId: string;
      program: UpdateProgramRequest;
    },
  ) {}
}

export class PageRangeChanged {
  static readonly type = "[Organization Programs] Page Range Changed";
  constructor(public payload: { schoolId: string; itemsPerPage: number }) {}
}

export class PageNumberChanged {
  static readonly type = "[Organization Programs] Page Number Changed";
  constructor(public payload: { schoolId: string; pageNumber: number }) {}
}
